import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const Count = styled.span`
  display: inline-block;
  color: #fff;
  background-color: #000;
  font-weight: 500;
  font-size: 11px;
  padding: 0 3px;
  border-radius: 20px;
  min-width: 20px;
  height: 20px;
  line-height: 20px;

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${mixin.pxToVw('10')};
    padding: ${mixin.pxToVw('0 3')};
    border-radius: ${mixin.pxToVw('20')};
    min-width: ${mixin.pxToVw('20')};
    height: ${mixin.pxToVw('20')};
    line-height: ${mixin.pxToVw('20')};
  }
`;
